<template>
  <div v-if="category">
    <div class="overlay" @click.self="$emit('closeModal')">
      <div class="modal">
        <div class="modal__head">
          <h1>
            {{ category.name }}
          </h1>
          <span class="modal__close" style="cursor: pointer" @click="$emit('closeModal')">
            <i class="fa fa-lg fa-close" aria-hidden="true"></i>
          </span>
        </div>
        <div class="modal__body">
          <p class="mb--lg">
            <strong>
              Voeg je eigen suggestie toe voor de categorie '{{ category.name.toLowerCase() }}'.</strong
            >
          </p>
          <template>
            <p>Wat is de <b>naam</b> en het <b>programma</b> van de suggestie?</p>
          </template>
          <form class="form" ref="form" @submit.prevent="submit">
            <div class="form__field">
              <input style=" background-color: #121212; color: #faf9f6; border: solid 1px #f2ad07;
              margin-bottom: 1rem; " type="text" required class="form__input" placeholder="Naam en programma*" v-model="suggestionName" id="form__field_name" />
            </div>
            <button
              class="button button--fullwidth"
              @click.prevent="addSuggestion"
              :disabled="isIncomplete()"
            >
              Voeg suggestie toe
            </button>
          </form>
        </div>
        <div
          :class="{
            'p--lg': windowHeight >= minHeight,
            'p--md': windowHeight < minHeight
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import listen from '@/util/listen'
import throttle from '@/util/throttle'

const MIN_HEIGHT = 490
const { documentElement } = document

export default {
  name: 'Suggestion',
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      listeners: [],
      minHeight: MIN_HEIGHT,
      windowHeight: window.innerHeight,
      suggestionName: null
    }
  },
  mounted() {
    const detectWindowHeight = throttle(() => {
      this.windowHeight = window.innerHeight
    }, 500)

    this.listeners = [listen(window, 'keyup', this.onKeyUp), listen(window, 'resize', detectWindowHeight)]

    documentElement.classList.add('no-scroll')
  },

  beforeDestroy() {
    this.listeners.forEach(unlisten => unlisten())
    documentElement.classList.remove('no-scroll')
  },
  methods: {
    submit() {
      if (this.isValid()) {
        this.addSuggestion()
      }
    },
    onKeyUp(e) {
      if (e.keyCode === 27) {
        this.$emit('closeModal')
      }
    },
    isValid() {
      return this.suggestionName && this.suggestionName.trim().length > 0
    },
    isIncomplete() {
      return !this.isValid()
    },
    addSuggestion() {
      const { categoryId, suggestionName } = this
      this.$store.dispatch('addSuggestion', {
        categoryId,
        suggestionName
      })
      this.$emit('closeModal')
    }
  },
  computed: {
    ...mapState(['selected', 'categories']),
    category() {
      return this.categories.find(({ id }) => id === this.categoryId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SuggestionModal.vue